import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { useQuery } from '@tanstack/vue-query';
import { getBootstrapData } from '@experience/core-hostapp-share-lib';
import type { GetExperiencesData, GetExperiencesResponse } from '@/shared/api/experience';
import type { Ref, MaybeRef } from 'vue';

export const useGetExperiencesPopular = (
  params: Ref<GetExperiencesData['query']>,
  enabled: MaybeRef<boolean> = true,
) => {
  const { getExperiences } = useExperienceApi();

  const excludeNeedsLicense = computed(() => {
    return getBootstrapData().hideUnlicensedExperiencesForPartner;
  });

  const {
    data: experiencesData,
    isFetching,
    isFetched,
  } = useQuery({
    queryKey: ['getExperiencesList', params],
    queryFn: async () => {
      const response = await getExperiences({
        query: {
          ...params.value,
          limit: 0,
          offset: 0,
          extended_movement_types: true,
          exclude_needs_license: excludeNeedsLicense.value,
          price_format: 'travelers' as const,
        },
      });

      return response.data;
    },
    enabled,
    placeholderData: (prevData): GetExperiencesResponse =>
      prevData || { count: 0, next: null, previous: null, results: [] },
    retry: false,
  });

  return {
    experiencesData,
    isFetching,
    isFetched,
  };
};
